const url = 'https://rod.eionet.europa.eu';

export const RodUrl = {
  obligations: `${url}/obligations/`,
  instruments: `${url}/instruments/`
};
